import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentDossierCtx } from '@europrocurement/l2d-modules/modules/Dossiers/providers/CurrentDossierProvider';
import {
    useIdPrescripteurCustomizer,
    usePrescripteursCustomizer,
    setIdPrescripteur,
} from '@europrocurement/l2d-domain';

const DossierPrescriberSyncer: React.FunctionComponent = function () {
    const { dossier } = useCurrentDossierCtx();
    const dispatch = useDispatch();
    const prescripteurs = usePrescripteursCustomizer();
    const currentPrescriberId = useIdPrescripteurCustomizer();

    const prescripteurId = dossier?.prescripteurId;
    const isInList = prescripteurs.some((p) => p.id === prescripteurId);

    useEffect(() => {
        if (prescripteurId && isInList && prescripteurId !== currentPrescriberId) {
            dispatch(setIdPrescripteur(prescripteurId));
        }
    }, [prescripteurId, isInList, currentPrescriberId, dispatch]);

    return null;
};

export default DossierPrescriberSyncer;
